import { gql } from '@apollo/client';

export const CREATE_IMAGE_FROM_URL = gql`
  mutation CreateImageFromUrl($url: String!, $namespace: String!) {
    createImageFromUrl(url: $url, namespace: $namespace) {
      id
      url
    }
  }
`;
